import '../../styles/test-system.css';

/**
 * The candidate's own standing on a cycle, which is not the cycle's status: a
 * running cycle can hold a confirmed spot and a returned entry side by side.
 *
 * It lives here rather than inside My Enrolments because the catalog says the same
 * thing about the same enrolment — and while it did not, a spot that had been
 * released for not confirming in time was still drawn on the catalog card as a
 * green "You're enrolled", under a heading that said the student was on the cohort,
 * on the same afternoon the dashboard and My Enrolments both said the spot was gone.
 */
export const ENROLMENT_CHIPS = Object.freeze({
    enrolled: { label: 'Enrolled', tone: '' },
    confirmed: { label: 'Participation confirmed', tone: 'ok' },
    no_show: { label: 'Not confirmed in time', tone: 'warn' },
    cancelled_credited: { label: 'Entry returned', tone: '' },
});

/**
 * @param {Object} props
 * @param {string} props.status - The enrolment's own status
 */
const EnrolmentStatusChip = ({ status }) => {
    const { label, tone } = ENROLMENT_CHIPS[status] || { label: status || 'Unknown', tone: '' };

    return (
        <span className={`ts-chip${tone ? ` ts-chip--${tone}` : ''}`} data-testid="enrolment-status">
            {label}
        </span>
    );
};

export default EnrolmentStatusChip;
